<template>
    <div class="edit" :class="`switch_${platformInfo.skin}`">
        <div class="by" :class="`bg-font_${platformInfo.skin}`">
            <span class="mr">美颜</span>
            <mt-switch v-model="beautyFlag"></mt-switch>
        </div>
        <div v-show="showUrl" class="imgwrap" :style="{'background-image':`linear-gradient(to bottom,#${processedPhoto.backcolor[0].s_color},#${processedPhoto.backcolor[0].e_color})`}">
            <img v-show="beautyFlag" :src="showUrl" class="img">
            <img v-show="!beautyFlag" :src="showUrl_no" class="img">
        </div>
        <div class="btngroup">
            <div class="saveele" v-if="showEle" :class="`bg-font_${platformInfo.skin} br-c_${platformInfo.skin}`" @click="savephoto">保存电子照</div>
            <div class="savepri" :class="`bg_${platformInfo.skin}`" @click="print">冲印排版照</div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import {
  Toast,
  Switch
} from "mint-ui";
export default{
    data(){
        return {
            beautyFlag:true,
            isIos: /iphone|ipad|ipod|ios/i.test(navigator.userAgent),
            showUrl_no:'',
            showUrl:''
        }
    },
    activated() {
        if(!this.actiBol){
        return;
        }
        console.log("processedPhoto:::",this.processedPhoto)
        console.log("platformInfo:::",this.platformInfo)
        this.platformInfo.platform==="baidu"?this.wxgetPhoto().then(res=>{
        this.processedPhoto.picinfo = res.data;
        this.ths.processedPhoto.picinfo.type="marriage"
        this.showUrl = res.data.wm_url
        this.showUrl_no = res.data.wm_url_no
        this.RECORD_PROCESSED_PHOTO(this.processedPhoto);
        this.showNoWayTip();
        }):this.showNoWayTip()
        let {wm_url,wm_url_no} = this.processedPhoto.picinfo
        this.showUrl = wm_url
        this.showUrl_no = wm_url_no
        this.RECORD_SELECTED_BG(0)
        this.closeKey = "";
    },
    methods:{
        ...mapActions(["wxgetPhoto","getorder","getWmPrintAndKey"]),
        ...mapMutations(['RECORD_PROCESSED_PHOTO','RECORD_SELECTED_BG','RECORD_PRINTINFO']),
        showNoWayTip() {
            !this.showEle&&Toast({
                message: '由于相关规范，苹果手机保存电子照功能暂不可用', 
                duration: 3000
            })
        },
        print() {
            let processedPhoto = this.processedPhoto;
            let data = {
                colors: processedPhoto.backcolor,
                spec_id: processedPhoto.specId,
                first_pic_no_fm: this.beautyFlag ? processedPhoto.picinfo.algo_fileuuid : processedPhoto.picinfo.algo_fileuuid_no
            }
            let ths = this;
            this.getWmPrintAndKey(data).then(res => {
                let d = res.data;
                let printinfo = {
                    sheets_number: d.number,
                    origin: {
                        imageUrl: d.bar_name_list_print_wm_url[0],
                        serialNumber: data.first_pic_no_fm
                    },
                    spec_name: processedPhoto.specName,
                    colors: processedPhoto.backcolor[0],
                    origin_name: processedPhoto.picinfo.ori_file_name,
                    spec_id: processedPhoto.specId
                };
                this.RECORD_PRINTINFO(printinfo);
                this.$router.push({
                name: "print"
                });
            })
        },
        savephoto(){
            let {backcolor,picinfo:{algo_fileuuid,algo_fileuuid_no,ori_file_name},specId} = this.processedPhoto
            let ad = this.beautyFlag?algo_fileuuid:algo_fileuuid_no
            let {channel} = this.extraInfo
            channel && delete this.extraInfo.channel
            let data={
                spec_id:specId,
                ori_file_name,
                colors:backcolor,
                fee:1,
                algo_fileuuid:ad,
                ...channel&&{share_channel:channel},
                extra:this.extraInfo
            }
            this.getorder(data).then(res=>{
                let { data:{order_id,params:option} } = res;
                option.description = "gopay";
                option.platform = this.platformInfo.platform;
                option.orderId=order_id;
                this.sdk.gopay(`pages/miniApi/miniApi`,option);
            })
        }
    },
    computed: {
        ...mapState(["price","processedPhoto", "platformInfo","actiBol","extraInfo"]),
        showEle() {
            //是否显示电子照按钮
            return this.sdk.name === 'alipay'?true: !this.isIos?true:false;
        }
    }
}
</script>
<style>
body{
    height:100%!important;
}
</style>
<style scoped>
.edit{
    width:100%;
    height:100%;
    background: url("../assets/wbg.png") no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top:0.24rem;
}
.by{
    display: flex;
    justify-content: flex-end;
    font-size: 0.16rem;
    align-items: center;
    box-sizing: border-box;
    padding-right: 0.16rem;
}
.mr{
    margin-right: 0.16rem;
}
.img{
    width:3.43rem;
    display: block;
}
.imgwrap{
    display: inline-block;
    margin:0 auto;
}
.btngroup{
    display: flex;
    height:0.8rem;
    box-sizing: border-box;
    padding:0 0.16rem;
    justify-content: space-between;
    align-items: center;
    background-color: white;
}
.saveele,.savepri{
    height:0.44rem;
    font-size: 0.17rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color:white;
    box-sizing: border-box;
    border-radius: 0.06rem;
    flex-grow: 1;
}
.saveele{
    margin-right: 0.09rem;
}
</style>